import { render } from "./ClericView.vue?vue&type=template&id=dbfb9f9a&scoped=true"
import script from "./ClericView.vue?vue&type=script&lang=js"
export * from "./ClericView.vue?vue&type=script&lang=js"

import "./ClericView.vue?vue&type=style&index=0&id=dbfb9f9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfb9f9a"]])

export default __exports__